import {combineReducers} from 'redux';

// Reducers
import profile from './profile';
import aggregations from './aggregations';
import balances from './balances';
import benefits from './benefits';
import identities from './identities';
import lists from './lists';
import rewards from './rewards';
import transactions from './transactions';
import action from './action';

// Combine Reducers
var reducers = combineReducers({
    profile,
    aggregations,
    balances,
    benefits,
    identities,
    lists,
    rewards,
    transactions,
    action
});

export default reducers;
